import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { useGetTaskTemplates } from '@/shared/hooks/task/useGetTaskTemplates';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';
import { listItemMsg } from '../../FormattedListValue';
const messages = defineMessages({
    TaskTemplates: {
        id: 'TaskTemplates',
        defaultMessage: 'Task templates',
    },
    TasksWithoutTemplate: {
        id: 'TasksWithoutTemplate',
        defaultMessage: 'Tasks without template',
    },
});
export const TaskTemplateMultiSelect = ({ selection, onChange, placeholder, }) => {
    const { formatMessage } = useIntl();
    const { data } = useGetTaskTemplates();
    const items = useMemo(() => [
        { id: guid.empty, label: formatMessage(messages.TasksWithoutTemplate) },
        ...(data !== null && data !== void 0 ? data : [])
            .map(item => ({
            id: item.id,
            label: formatMessage(listItemMsg('taskTemplate', item.id, item.name)),
        }))
            .sort(dynamicSort('label')),
    ], [data, formatMessage]);
    const [selectedItems, selectableItems] = splitItems(items, selection);
    return (_jsx(MultiSelect, { selectedItem: selectedItems, onItemRemoved: item => onChange(removeItem(selection, item)), onItemSelected: item => onChange(addItem(selection, item)), items: selectableItems, placeholder: placeholder || formatMessage(messages.TaskTemplates) }));
};
